import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import KiranaStore from "@/pages/KiranaStore";
import Admin from "@/pages/Admin";
import MohallaGames from "@/pages/MohallaGames";
import WorldHub from "@/pages/WorldHub";
import SchoolClassroom from "@/pages/SchoolClassroom";
import LivingRoomTv from "@/pages/LivingRoomTv";
import GameRoom from "@/pages/GameRoom";

function GATracker() {
  const location = useLocation();
  useEffect(() => {
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
      });
    }
  }, [location]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <GATracker />
        <Routes>
          <Route path="/" element={<WorldHub />} />
          <Route path="/kirana" element={<KiranaStore />} />
          <Route path="/games" element={<MohallaGames />} />
          <Route path="/school" element={<SchoolClassroom />} />
          <Route path="/tv" element={<LivingRoomTv />} />
          <Route path="/parlor" element={<GameRoom />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#FDF6E3",
            color: "#2D241E",
            border: "2px solid #D4A373",
            fontFamily: "Outfit, sans-serif",
            boxShadow: "4px 4px 0 0 #2D241E",
          },
        }}
      />
    </div>
  );
}

export default App;
